import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { getContent } from '../utils/contentStore';
import { renderIcon } from '../utils/iconMap';
import { useLanguage } from '../utils/i18n';
export function ApplicationAreas() {
  const areas = getContent().applicationAreas;
  const content = getContent().areasSection;
  const {
    t,
    loc
  } = useLanguage();
  return <Section id="applications" className="bg-gray-50" data-id="element-23">
      <div className="text-center mb-16" data-id="element-24">
        <h2 className="text-gray-500 font-bold tracking-widest uppercase mb-3 text-sm" data-id="element-25">
          {loc(content.label)}
        </h2>
        <h3 className="font-heading text-4xl md:text-5xl font-bold text-gray-900 uppercase leading-tight" data-id="element-26">
          {loc(content.title1)}{' '}
          <span className="text-red-600" data-id="element-27">{loc(content.title2)}</span>
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-28">
        {areas.map((area, index) => <motion.div key={area.id} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.45,
        delay: index * 0.05,
        ease: 'easeOut'
      }} className="bg-white p-8 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-300 border-b-4 border-transparent hover:border-gray-800 group" data-id="element-29">
            <div className="mb-6 text-gray-400 group-hover:text-gray-700 transition-colors duration-300" data-id="element-30">
              {renderIcon(area.icon, 'h-10 w-10')}
            </div>
            <h4 className="font-heading text-xl font-bold mb-3 text-gray-900" data-id="element-31">
              {loc(area.title)}
            </h4>
            <p className="text-gray-600 leading-relaxed" data-id="element-32">
              {loc(area.description)}
            </p>
          </motion.div>)}
      </div>
    </Section>;
}